import { wrapWithMaxWidth } from '../../../echarts/util/tooltip';

export default function tooltipFormatter(params) {
  const { metadata } = params.data;

  if (!metadata) {
    return params.data.name;
  }

  const { pergunta } = metadata;
  const { marker } = params;

  const header = `${marker} <strong>${pergunta}</strong>`;

  const { alternativa } = metadata;
  const { correlacao } = metadata;

  let body;
  if (correlacao) {
    body = `<strong>${alternativa}</strong>: ${correlacao}`;
  } else {
    body = `<strong>${alternativa}</strong>`;
  }

  return wrapWithMaxWidth(`${header}<br/>${body}`);
}
